module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/310.87a3c5fb.png";